import {Component, Injector, OnDestroy, ViewChild} from '@angular/core';
import {ModalFormComponentInterface} from '@interfaces/modal-form-component.interface';
import {ModalComponent} from '@components/modal/modal.component';
import {FrontendFormComponent} from '@abstract/frontend.form.component';
import {TechnicalDeviceNamespace} from '@namespaces/technical-device.namespace';
import {untilDestroyed} from 'ngx-take-until-destroy';
import {ActivatedRoute, Router} from '@angular/router';
import {TechnicalDeviceDataService} from '../../services/technical-device-data.service';
import {TechnicalDeviceTechnicalCardApiService} from '@api/technical-device-technical-card.api.service';
import {FormHelperService} from '@services/form-helper.service';
import {NotyMessagesEnum} from '@helpers/noty-messages.enum';
import {RoutesStorage} from '@helpers/routes.helper';

@Component({
    selector: 'app-elements-group-tech-card-modal-form',
    templateUrl: 'elements-group-tech-card-modal-form.component.html'
})

export class ElementsGroupTechCardModalFormComponent extends FrontendFormComponent implements ModalFormComponentInterface, OnDestroy {
    public isFetching = true;

    @ViewChild(ModalComponent) modal: ModalComponent;

    modalTitle = 'Техкарта';

    form = this._fb.group({
        number: [''],
        date: [''],
        file: this._fb.group({})
    });

    public afterSaveMessage = NotyMessagesEnum.technicalDeviceTechnicalCardUpdatedMessage;

    private technicalCardId: number;

    constructor(
        injector: Injector,
        public formService: TechnicalDeviceTechnicalCardApiService,
        private router: Router,
        private route: ActivatedRoute,
        private dataService: TechnicalDeviceDataService,
    ) {
        super(injector);
    }

    get saveUrl(): string {
        return this.formService.getDocumentPath(this.technicalCardId);
    }

    init() {
        this.technicalCardId = this.route.snapshot.params.technicalCardId;

        if (this.technicalCardId) {
            this.formService.get({
                url: this.formService.getDocumentPath(this.technicalCardId),
            }).pipe(
                untilDestroyed(this)
            ).subscribe((doc: TechnicalDeviceNamespace.TechnicalCardDocument) => {
                if (doc) {
                    FormHelperService.setFormValues(doc, this.form);
                }
                this.isFetching = false;
            }, () => {
                this.isFetching = false;
            });
        } else {
            this.isFetching = false;
        }
    }

    onModalClose() {
        this.router.navigate([RoutesStorage.TechnicalDevice.viewElementGroups(this.dataService.deviceId)]);
    }

    afterSave() {
        super.afterSave();
        this.isPending = false;
        this.dataService.technicalCardUpdated$.next();
        this.modal.close();
    }

    ngOnDestroy() {

    }
}
